export default __webpack_public_path__ + "static/media/haier.ab936617.svg";